<template>
    <div class="container-fluid my-3 py-3">
        <div class="row my-3">
            <div class="col-8">
                <div class="form-floating">
                    <input id="inputName" ref="name" type="text" name="name" class="form-control"  v-model="plantJournalHeader.name" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("name") }}</label>
                </div>
            </div>                
        </div>
        <div class="text-danger" v-if="errors.length">
            <p v-for="error in errors" v-bind:key="error">{{ error }}</p>
        </div>
        <button class="btn btn-success mb-0 ms-auto" @click="submitForm">{{ $t("save") }}</button>
    </div>
</template>

<script>
import { createToast } from '@/assets/js/myToast.js'
import axios from 'axios'
export default {
    name: 'AddPlantJournalHeader',
    emits: ['closeModal'],
    props: {
        plantSystemJournal: {
            type: Object,
            required: true,
        },
        position: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            plantJournalHeader: {
                name: ''
            },
            errors: [],
        }
    },
    mounted(){
        console.log('entry mounted')
        this.focusInput()
        console.log('exit mounted')
    },
    methods: {
        focusInput() {
            console.log('entry focusInput')
            console.log(this.$refs.name)
            this.$refs.name.focus();
            console.log('exit focusInput')
        },
        submitForm() {
            this.plantJournalHeader.plant_system_journal = this.plantSystemJournal.id
            this.plantJournalHeader.created_by = this.$store.state.me.id
            this.plantJournalHeader.modified_by = this.$store.state.me.id
            this.plantJournalHeader.position = this.position
            
            axios
                .post(`/api/v1/plant_system_journal_headers/`, this.plantJournalHeader)
                .then(response => {
        
                    createToast({text: this.$t("header added")
                        ,type: 'success'})
                    this.plantJournalHeader.name = ''

                this.$emit('closeModal', 'add', response.data)
                })
                .catch(error => {
                    if (error.response) {
                        if ('detail' in error.response.data){
                            createToast({text: this.$t(error.response.data['detail'])
                                        ,type: 'error'})
                        }                        
                        console.error(JSON.stringify(error.response.data))
                    } else if (error.message) {
                        console.error(JSON.stringify(error.message))
                    } else {
                        console.error(JSON.stringify(error))
                    }
                })
        }
    },
    computed:{
    }
}
</script>